export default "__VITE_ASSET__vJpm9Tn8__"